import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Button,
  IconButton,
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';

const MappingRow = ({ k, v, changeKey, changeValue, deleteRow, keyColumnLabel, valueColumnLabel, keyPlaceholder, valuePlaceholder }) => {
  // Extracted so we can keep local state and commit the key on blur,
  // allowing the key text field to be edited freely (including duplicates mid-edit).
  const [k_, setK] = useState(k);
  return (
    <TableRow>
      <TableCell>
        <TextField fullWidth label={keyColumnLabel} variant="standard" placeholder={keyPlaceholder} required value={k_} onChange={(e) => setK(e.target.value)} onBlur={() => changeKey(k, k_)} />
      </TableCell>
      <TableCell>
        <TextField fullWidth label={valueColumnLabel} variant="standard" placeholder={valuePlaceholder} required value={v} onChange={(e) => changeValue(k, e.target.value)} />
      </TableCell>
      <TableCell>
        <IconButton aria-label="Delete row" onClick={() => deleteRow(k)}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export const MappingTableCard = ({
  title,
  subheader,
  keyColumnLabel,
  valueColumnLabel,
  keyPlaceholder,
  valuePlaceholder,
  useJobConfig,
  fieldPath,
}) => {
  const [_mapping, setMapping] = useJobConfig(fieldPath);
  const mapping = _mapping || {};

  function addRow() {
    setMapping({ ...mapping, '': '' });
  }
  function deleteRow(key) {
    setMapping(Object.fromEntries(Object.entries(mapping).filter(([k]) => k !== key)));
  }
  function changeKey(key, newKey) {
    setMapping(
      Object.fromEntries(
        Object.entries(mapping).map(([k, v]) => (k === key ? [newKey, v] : [k, v])),
      ),
    );
  }
  function changeValue(key, newValue) {
    setMapping(
      Object.fromEntries(
        Object.entries(mapping).map(([k, v]) => (k === key ? [k, newValue] : [k, v])),
      ),
    );
  }

  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{keyColumnLabel}</TableCell>
              <TableCell>{valueColumnLabel}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(mapping).length > 0 ? (
              Object.entries(mapping).map(([k, v]) => (
                <MappingRow
                  key={k}
                  k={k}
                  v={v}
                  changeKey={changeKey}
                  changeValue={changeValue}
                  deleteRow={deleteRow}
                  keyColumnLabel={keyColumnLabel}
                  valueColumnLabel={valueColumnLabel}
                  keyPlaceholder={keyPlaceholder}
                  valuePlaceholder={valuePlaceholder}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No mapping configured</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Button startIcon={<AddIcon />} variant="outlined" onClick={addRow}>
          Add row
        </Button>
      </CardContent>
    </Card>
  );
};
